import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../_services';
import { Router } from '@angular/router';
import { User } from 'src/app/_models';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css'],
})
export class SideNavComponent implements OnInit {
  cUser: User = JSON.parse(localStorage.getItem('currentUser'));
  Name: string = this.cUser?.name;
  Email: string = this.cUser?.email;
  Role: string = this.cUser?.roles;

  isCSPUser: boolean = false;
  isAdminUser: boolean = false;
  issubscription: boolean = false;

  constructor(private authSvc: AuthenticationService, private router: Router) {}

  ngOnInit(): void {
    this.cUser = JSON.parse(localStorage.getItem('currentUser'));
    this.isCSPUser = this.cUser.roles == 'CSP' ? true : false;
    this.isAdminUser = this.cUser.roles == 'Admin' ? true : false;
    // var subscr =  this.cUser.subscriptionStatus;
    //this.issubscription = subscr;
    this.issubscription = this.cUser.subscriptionStatus == true ? true : false;
    //  console.log(this.cUser.subscriptionStatus)
    // console.log(this.issubscription)
    // console.log(this.cUser)
  }

  logout() {
    let res = this.authSvc.logout();
    if (res) {
      //this.router.navigate(["/#login"]);
      window.location.href = '/#login';
      window.location.reload();
    }
  }
}
